<template>
    <!-- <v-container fluid> -->
        <div>
            <div class="text-h6 my-4 font-weight-black text-uppercase">Settings</div>
                    
            <v-tabs centered grow class="settings" v-model="tabs" background-color="primary">
                
                <v-tab class="text-left white--text">Twilio Settings</v-tab>
                <v-tab class="text-left white--text">Phone Numbers</v-tab>
                <v-tab class="text-left white--text">Phone Settings</v-tab>
                <v-tab class="text-left white--text">Audio Files</v-tab>
                

                <!-- BM: TWILIO SETTINGS -->
                <v-tab-item class="py-8 px-4 settings-tab">
                    <div class="text-h6 font-weight-bold">Twilio Settings</div>
                    <v-card>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field v-model="user.twilio.sid" label="Account SID" outlined />
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="user.twilio.token" label="Auth Token" type="password" outlined />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    API Key: 
                                        <span v-if="user.twilio && user.twilio.apiKey && user.twilio.apiKey != ''" class="secondary--text">{{user.twilio.apiKey}}</span>
                                        <span v-else class="secondary--text">Not set</span>
                                </v-col>
                                <v-col>
                                    Application SID: 
                                        <span v-if="user.twilio && user.twilio.applicationSid && user.twilio.applicationSid != ''" class="secondary--text">{{user.twilio.applicationSid}}</span>
                                        <span v-else class="secondary--text">Not set</span>
                                </v-col>
                            </v-row>
                            <!-- 
                                <v-btn fluid @click="createApiKey">Create API Key</v-btn>
                                <v-btn fluid @click="createTwimlApp">Create Twiml App</v-btn> 
                            -->
                            <v-btn fluid @click="checkTwilioSettings" class="mt-8" :loading="is_checking_settings" :disabled="is_checking_settings">Check Settings</v-btn>
                            <div v-if="check_results != null" class="pa-4">
                                <div class="ma-1">
                                    Twilio SID/Token: 
                                    <v-icon small v-if="check_results.twilio === true" color="success">mdi-check-circle</v-icon>
                                    <v-icon small v-else color="error">mdi-close-circle</v-icon>
                                </div>
                                <div class="ma-1">
                                    API Key: 
                                    <v-icon small v-if="check_results.api === true" color="success">mdi-check-circle</v-icon>
                                    <v-icon small v-else color="error">mdi-close-circle</v-icon>
                                </div>
                                <div class="ma-1">
                                    Application SID: 
                                    <v-icon small v-if="check_results.app === true" color="success">mdi-check-circle</v-icon>
                                    <v-icon small v-else color="error">mdi-close-circle</v-icon>
                                </div>
                            </div>

                            <v-switch 
                                :value="darkMode" 
                                @change="toggleDarkMode" 
                                :label="`Toggle ${switchLabel} mode`"
                            ></v-switch>

                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <!-- BM: PHONE NUMBERS TAB -->
                <v-tab-item class="py-8 px-4 settings-tab">
                    <div class="text-h6 mb-2 font-weight-bold">
                        <span v-if="show_phone == 'list'" class="mr-2">Phone Numbers</span>
                        <span v-if="show_phone == 'buy'" class="mr-2">Buy Phone Number</span>
                        <span v-if="show_phone == 'edit'" class="mr-2">Edit Phone Number</span>
                        <v-btn v-if="show_phone == 'list'" icon @click="show_phone = 'buy'" small color="primary">
                            <v-icon>
                                mdi-plus
                            </v-icon>
                        </v-btn>
                        <v-btn v-if="show_phone == 'list'" icon 
                            @click="phone_numbers.fetchPhoneNumbers()" small 
                                color="primary" class="ml-2"
                            :loading="phone_numbers.loading"
                        >
                            <v-icon>
                                mdi-refresh
                            </v-icon>
                        </v-btn>
                        <v-btn v-else icon @click="show_phone = 'list'" small outlined color="primary">
                            <v-icon>
                                mdi-arrow-left
                            </v-icon>
                        </v-btn>
                    </div>

                    <!-- BM: PHONE NUMBERS LIST -->
                    <v-data-table
                        v-if="show_phone == 'list'"
                        :headers="phone_numbers_headers"
                        :items="phone_numbers.numbers"
                        :items-per-page="5"
                        class="elevation-1"
                        style="border:none;"
                        :loading="phone_numbers.loading"
                        loading-text="Loading..."
                        :single-select="false"
                        item-key="sid"
                        :hide-default-footer="phone_numbers.numbers.length <= 5"
                    >
                        <!-- <template v-slot:item.actions> -->
                        <template v-slot:item.connected="{ item }">
                            <v-icon color="success" v-if="user.twilio.applicationSid == item.voice_application_sid">mdi-check-circle</v-icon>
                            <v-icon color="warning" v-else>mdi-alert-circle</v-icon>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn icon @click="editPhoneNumber(item)"><v-icon>mdi-pencil</v-icon></v-btn>
                        </template>
                    </v-data-table>




                    <!-- BM: EDIT PHONE NUMBER -->
                    <v-card v-if="show_phone == 'edit'" rounded class="pa-4" elevation="1">
                        <v-card-title>
                            <v-text-field v-if="editing_friendly_name" label="Phone Number Name" v-model="editing_phone_number.friendly_name" outlined>
                                <template v-slot:append>
                                    <v-btn icon @click="editing_friendly_name = false; phone_numbers.saveFriendlyName(editing_phone_number);"><v-icon>mdi-check</v-icon></v-btn>
                                </template>
                            </v-text-field>
                            <span v-else>
                                {{editing_phone_number.friendly_name}}
                                <v-btn icon @click="editing_friendly_name = true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </span>
                        </v-card-title>
                        <!-- <v-card-subtitle>{{editing_phone_number.phone_number}}</v-card-subtitle> -->

                        <v-card-text>
                            <v-alert v-if="phoneIsConnected" icon="mdi-check-circle" color="success" text><span class="font-weight-black">{{editing_phone_number.phone_number}}</span> is fully connected.</v-alert>
                            <v-alert v-else text color="warning" icon="mdi-alert-circle" prominent> 
                                <v-row align="center">
                                    <v-col class="grow">
                                        <span class="font-weight-black">{{editing_phone_number.phone_number}}</span> is not fully connected.
                                    </v-col>
                                    <v-col class="shrink">
                                        <v-btn v-if="!phoneIsConnected" 
                                            @click="connectPhoneNumber" 
                                            :loading="is_connecting_phone_number" 
                                            :disabled="is_connecting_phone_number"
                                            color="warning"
                                        >
                                            Connect
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-alert>
                            
                            <v-divider></v-divider>
                            
                            <phone-settings :phoneSid="editing_phone_number.sid" />
                            
                        </v-card-text>
                    </v-card>



                    <!-- BM: BUY PHONE NUMBER -->
                    <v-sheet v-if="show_phone == 'buy'" rounded class="pa-4 mb-4" elevation="1">
                        <v-form>
                            <v-row>
                                <v-col cols="4">
                                    <v-text-field label="Area Code" :rules="areaCodeRules" v-model="search.area_code" :hide-details="false" outlined></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field label="Contains" v-model="search.contains" :hide-details="false" outlined></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-btn color="secondary" x-large class="mr-2" @click="searchPhoneNumbers" block elevation="0" :loading="phone_numbers_searching">
                                        <v-icon>mdi-magnify</v-icon>
                                        Search
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-sheet>


                    <!-- BM: AVAILABLE PHONE NUMBERS TAB-->
                    <v-data-table
                        v-if="show_phone == 'buy' && (available_phone_numbers.length > 0 || phone_numbers_searching)"
                        :headers="available_phone_numbers_headers"
                        :items="available_phone_numbers"
                        :items-per-page="5"
                        class="elevation-1"
                        style="border:none;"
                        :loading="phone_numbers_searching"
                        loading-text="Searching..."
                        :single-select="false"
                        item-key="phone_number"
                        :hide-default-footer="available_phone_numbers.length <= 5"
                    >
                        <template v-slot:item.locality="{ item }">
                            <span v-if="item.locality">{{item.locality}}, {{item.region}}</span>
                            <span v-else>{{item.region}}</span>
                        </template>
                        <template v-slot:item.capabilities.voice="{item}">
                            <v-icon v-if="item.capabilities.voice == true" color="success">mdi-check-circle</v-icon>
                            <v-icon v-else color="error">mdi-close-circle</v-icon>
                        </template>
                        <template v-slot:item.capabilities.SMS="{item}">
                            <v-icon v-if="item.capabilities.SMS == true" color="success">mdi-check-circle</v-icon>
                            <v-icon v-else color="error">mdi-close-circle</v-icon>
                        </template>
                        <template v-slot:item.capabilities.MMS="{item}">
                            <v-icon v-if="item.capabilities.MMS == true" color="success">mdi-check-circle</v-icon>
                            <v-icon v-else color="error">mdi-close-circle</v-icon>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn small @click="showBuyDialog(item)"><v-icon>mdi-currency-usd</v-icon></v-btn>
                        </template>
                    </v-data-table>
                    <div class="text-h5 font-weight-bold text-center grey--text darken-2 mt-4" v-if="show_no_results">No results</div>
                </v-tab-item>

                <!-- BM: DEFAULT PHONE SETTINGS TAB -->
                <v-tab-item class="py-8 px-4 settings-tab">
                    <div class="text-h6 font-weight-bold mb-6">Default Phone Settings</div>
                    <p>These settings will serve as the default settings for all phone numbers unless overridden by custom setting on the individual phone numbers.</p>
                    <phone-settings></phone-settings>
                </v-tab-item>

                <!-- BM: AUDIO FILES TAB -->
                <v-tab-item class="py-8 px-4 settings-tab">
                    <div class="text-h6 font-weight-bold">Audio Files 
                        <v-btn icon 
                            @click="user.fetchAudioFiles()" 
                            color="primary" 
                            class="ml-2"
                            small
                        ><v-icon>mdi-refresh</v-icon></v-btn>
                    </div>
                    <audio-files></audio-files>
                </v-tab-item>
            </v-tabs>
                
            <div class="mt-4" v-if="tabs == 0">
                <v-btn
                    color="success"
                    @click="user.saveUserSettings()"
                    :loading="user.saving_user_settings"
                    :disabled="user.saving_user_settings"
                >
                    Save Twilio Settings
                </v-btn>
            </div>

            <!-- BUY PHONE NUMBER CONFIRMATION DIALOG -->
            <v-dialog
                width="60%"
                max-width="500"
                v-model="show_buy_dialog"
            >
                <v-card>
                    <v-card-title class="text-h5">
                        Buy Phone Number {{selected_available_phone_number.friendly_name}}
                    </v-card-title>
                    <v-card-text>
                        Are you sure you want to buy <strong>{{selected_available_phone_number.friendly_name}}</strong>? Your twilio account will be charged accordingly.
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="show_buy_dialog = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            color="success"
                            @click="buyPhoneNumber"
                            :loading="is_buying_phone_number"
                            :disabled="is_buying_phone_number"
                        >
                            <v-icon>mdi-currency-usd</v-icon> Buy Now
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    <!-- </v-container> -->
</template>

<script>
import { useUserStore } from "../stores/user"
import { usePhoneNumbersStore } from "../stores/phone_numbers"
import { useAppStore } from "../stores/app"
import PhoneSettings from "./PhoneSettings.vue"
import AudioFiles from './AudioFiles.vue'

export default {
    name: 'Settings',
    props: {
        set_tab: {
            default: 0
        }
    },
    components: {
        PhoneSettings,
        AudioFiles
    },
    created: function() {
        this.app = useAppStore()
        this.user = useUserStore()
        this.phone_numbers = usePhoneNumbersStore()
        this.tabs = this.set_tab
    },
    data: () => ({
        darkMode: true,
        tabs: 0,
        phone_settings_tabs: 0,
        user: null,
        showDialog: true,
        notifications: false,
        sound: true,
        widgets: false,
        // phone_numbers_loading: false,
        phone_numbers: [],
        phone_numbers_headers: [    
            {
                text: 'Phone Numbers',
                align: 'start',
                sortable: true,
                value: 'phone_number',
            },
            {
                text: 'Name',
                align: 'start',
                sortable: true,
                value: 'friendly_name',
            },
            {
                text: 'Connected',
                value: 'connected',
                align: 'center',
                sortable: true,
            },
            {
                text: '',
                value: 'actions',
                align: 'center',
                sortable: false
            }
        ],
        show_phone: 'list',
        search: {
            area_code: "",
            contains: "",
        },
        seaching: false,
        areaCodeRules: [
            v => !!v || 'Area Code is required',
            v => v.length == 3 || 'Area Code must be 3 digits',
        ],
        available_phone_numbers: [],
        available_phone_numbers_headers: [
            
            {
                text: 'Phone Number',
                align: 'start',
                sortable: true,
                value: 'friendly_name',
            },
            {
                text: 'Locality',
                align: 'start',
                sortable: true,
                value: 'locality'
            },
            {
                text: 'Voice',
                alight: 'start',
                sortable: true,
                value: 'capabilities.voice'
            },
            {
                text: 'SMS',
                alight: 'start',
                sortable: true,
                value: 'capabilities.SMS'
            },
            {
                text: 'MMS',
                alight: 'start',
                sortable: true,
                value: 'capabilities.MMS'
            },
            {
                text: 'Buy',
                value: 'actions',
                align: 'center',
                sortable: false
            }
        ],
        phone_numbers_searching: false,
        show_no_results: false,
        show_buy_dialog: false,
        selected_available_phone_number: {},
        is_buying_phone_number: false,
        is_checking_settings: false,
        check_results: null,
        editing_phone_number: null,
        editing_friendly_name: false,
        is_connecting_phone_number: false
    }),
    computed: {
        phoneIsConnected: function() {
            return this.user.twilio.applicationSid == this.editing_phone_number.voice_application_sid
                && this.user.twilio.applicationSid == this.editing_phone_number.sms_application_sid
        },
        switchLabel: function () {
            return this.darkMode ? 'light' : 'dark';
        }
    },
    methods: {
        toggleDarkMode: function () {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
            this.darkMode = !this.darkMode;
        },
        // saveTwilioSettings: function() {
        //     this.user.saveUserSettings()
        // },
        // updateUserTwilio: function() {

        // },
        editPhoneNumber: function(phone_number) {   
            console.log("edit", phone_number)
            this.editing_phone_number = phone_number
            this.show_phone = "edit"
        },
        searchPhoneNumbers: function() {
            this.available_phone_numbers = []
            this.phone_numbers_searching = true
            this.show_no_results = false
            this.app.req.post(`twilio/phone_numbers/search`, this.search)
            .then(data => {
                console.log(data)
                this.phone_numbers_searching = false
                this.available_phone_numbers = data.available_phone_numbers
                if(data.available_phone_numbers.length == 0)
                    this.show_no_results = true
            })
        },
        showBuyDialog: function(phone_number) {
            this.selected_available_phone_number = phone_number
            this.show_buy_dialog = true
        },
        buyPhoneNumber: function() {
            this.is_buying_phone_number = true
             this.app.req.post(`twilio/phone_numbers/buy`, this.selected_available_phone_number)
            .then(data => {
                this.is_buying_phone_number = false
                this.app.showSuccess("Phone number successfully purchased.")
                this.phone_numbers.fetchPhoneNumbers()
                this.show_buy_dialog = false
                this.show_phone = 'list'
            })
            .catch(error => {
                this.app.showError(error.message)
                this.is_buying_phone_number = false
            })
        },
        createApiKey: function() {
            this.app.req.post('twilio/create_api_key')
            .then(data => console.log(data))
        },
        createTwimlApp: function() {
            this.app.req.post('twilio/create_twiml_app')
            .then(data => console.log(data))
        },
        checkTwilioSettings: function() {
            this.is_checking_settings = true
            this.check_results = null
            this.app.req.get('twilio/check_settings')
            .then(data => {
                this.is_checking_settings = false
                this.check_results = data
            })
        },
        connectPhoneNumber: function() {
            this.is_connecting_phone_number = true
            this.app.req.post('twilio/connect_phone_number', 
            {
                phone_sid: this.editing_phone_number.sid,
                application_sid: this.user.twilio.applicationSid
            })
            .then(data => {
                this.is_connecting_phone_number = false
                if(data.voice_application_sid == this.user.twilio.applicationSid) {
                    this.app.showSuccess("Successfully connected phone number.")
                    this.editing_phone_number = data
                    this.phone_numbers.fetchPhoneNumbers()
                }
            })
        }
    },
    watch: {
        'set_tab': function(newV) {
            console.log("set_tab", newV, this.tabs)
            if(newV != this.tabs)
                this.tabs = newV
        }
    }
}
</script>

<style scoped>
.settings-tab {
    min-height: 430px;
}
</style>